import { memo } from 'react';
import type { LucideIcon } from 'lucide-react';
import { panelLead, panelTitle } from './panelHeader.styles.js';

export interface SettingsPageHeaderProps {
  readonly icon: LucideIcon;
  readonly title: string;
  readonly description: string;
  readonly eyebrow?: string;
  readonly className?: string;
  readonly 'data-testid'?: string;
}

export const SettingsPageHeader = memo(
  ({
    icon: Icon,
    title,
    description,
    eyebrow,
    className = '',
    'data-testid': dataTestId,
  }: SettingsPageHeaderProps): JSX.Element => {
    const rootClass = ['sic-panel-head', 'flex items-start gap-[var(--space-4)]', className]
      .filter((part) => part.length > 0)
      .join(' ');

    return (
      <header className={rootClass} data-testid={dataTestId ?? 'settings-page-header'}>
        <span
          aria-hidden
          className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-[var(--radius-md)] border border-[var(--color-an-border)] bg-[var(--color-an-primary-soft)] text-[var(--color-an-primary)]"
        >
          <Icon className="h-5 w-5 stroke-[1.75]" />
        </span>
        <div className="min-w-0">
          {eyebrow != null && eyebrow !== '' ? (
            <p className="text-xs font-semibold uppercase tracking-wide text-[var(--color-an-primary)]">
              {eyebrow}
            </p>
          ) : null}
          <h2 className={panelTitle()}>{title}</h2>
          <p className={panelLead()}>{description}</p>
        </div>
      </header>
    );
  },
);

SettingsPageHeader.displayName = 'SettingsPageHeader';
